import(/* webpackMode: "eager" */ "/tmp/8dea3a4fa390c27/app/global-error.tsx");
